import { render, staticRenderFns } from "./MenuImageBatchUpload.vue?vue&type=template&id=4286e070"
import script from "./MenuImageBatchUpload.vue?vue&type=script&lang=ts"
export * from "./MenuImageBatchUpload.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../qraved-ordering-backoffice/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports